import type { ActionConfig } from "../ActionConfig";
import { NonDatabaseActionActionConfig } from "./NonDatabaseActionActionConfig";
import { Action, DatabaseAction, ExpandedAction } from "../../Action";
import { Dispatch, SetStateAction } from "react";
import { Match } from "../../../../requests/matches";
import { DetailedEvent } from "../../../../requests/matchEvents";

export class PermanentOverrideActionConfig extends NonDatabaseActionActionConfig {
  constructor() {
    super(ExpandedAction.permanentOverride);
  }

  getButtonPhrase = () => "Permanent Override";
  isValid = () => true;
  doAction = async (
    _previousEvents: DetailedEvent[],
    _createEvent: (
      action: DatabaseAction,
      possessionTeamId: number,
      locX: number,
      locY: number
    ) => void,
    _pseudoEventActions: Set<ExpandedAction>,
    setPseudoEventActions: Dispatch<SetStateAction<Set<ExpandedAction>>>,
    _match: Match,
    _actionConfigs: Record<Action, ActionConfig>,
    _locX?: number,
    _locY?: number
  ): Promise<void> =>
    setPseudoEventActions((prevState) => {
      const newState = new Set(prevState);
      if (prevState.has(ExpandedAction.permanentOverride)) {
        newState.delete(ExpandedAction.override);
        newState.delete(ExpandedAction.permanentOverride);
      } else {
        newState.add(ExpandedAction.override);
        newState.add(ExpandedAction.permanentOverride);
      }

      return newState;
    });
}
